import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule, Routes } from '@angular/router';
import { MatNativeDateModule, MatButtonModule, MatCheckboxModule } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
//import { MdIconModule, MdIconRegistry } from '@angular2-material/icon';

import 'hammerjs';
import 'leaflet/dist/leaflet.css';
import { TranslateModule } from 'ng2-translate';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { ClipboardModule } from 'ngx-clipboard';
import { MatVideoModule } from 'mat-video';
import { DndModule } from 'ng2-dnd';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
// Imports for loading & configuring the in-memory web api
// import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
// import { InMemoryDataService }  from './in-memory-data.service';
import { DragulaModule } from "ng2-dragula";
import { TagInputModule } from 'ngx-chips';
import { LoadersCssModule } from 'angular2-loaders-css';
import { ToastyModule } from 'ng2-toasty';
import { AmazingTimePickerModule, AmazingTimePickerService } from 'amazing-time-picker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';


import { AppComponent } from './app.component';
import { OldCentralPannelComponent } from './oldCentralPannel/old-central-pannel.component';
import { CreateQuestionnaireComponent } from './createQuestionnaire/create-questionnaire.component';
import { LeftPannelComponent } from './leftPannel/left-pannel.component';
import { QuestionnairePreviewComponent } from './questionnairePreview/questionnaire-preview.component';
import { LogInDialogComponent } from './logInComponent/log-in.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ManagerSurveyComponent } from './manager/manager.component';
import { NewManagerDialogComponent } from './manager/new-manager'
import { PriceComponent } from './price/price.component';
import { EditQuestionDialogComponent } from './editQuestionDialog/edit-question-dialog.component';
import { BroadcastEventService } from './shared/services/broadcast.event.service';
import { GetQuestionsFromJson } from './shared/services/get-questions-from-json';

// Components for Question Types
import { CheckboxTypeComponent } from './questions-type/checkbox/checkbox-type.component';
import { RadioTypeComponent } from './questions-type/radio-type/radio-type.component';
import { RatingTypeComponent } from './questions-type/rating-type/rating-type.component';
import { TimeTypeComponent } from './questions-type/time-type/time-type.component';
import { EmojiTypeComponent } from './questions-type/emoji-type/emoji-type.component';
import { RankTypeComponent } from './questions-type/rank-type/rank-type.component';
import { SectionBreakComponent } from './questions-type/section-break-type/section-break-type'
import { RangetypeComponent } from './questions-type/range-type/range-type.component'
import { MapTypeComponent } from './questions-type/map/map-type.component';
import { PictureInputTypeComponent } from './questions-type/picture-input-type/picture-input-type.component';
import { SelectedDropdownTypeComponent } from './questions-type/selected-dropdown/selected-dropdown-type.component';
import { CalendarTypeComponent } from './questions-type/calendar-type/calendar-type.component';
import { CalendarTypeDialogComponent } from './questions-type/calendar-type/calendar-type-dialog/calendar-type-dialog.component';
import { MobileNumTypeComponent } from './questions-type/mobile-num-type/mobile-num-type.component';
import { SubjectiveTypeComponent } from './questions-type/subjective-type/subjective-type.component';
import { NaturalWholeNumTypeComponent } from './questions-type/natural-whole-decimal-num-type/natural-whole-decimal-num-type.component';
import { CalendarWithDateTypeComponent } from './questions-type/calendar-with-date-type/calendar-with-date-type.component';
import { AudioTypeComponent } from './questions-type/audio-type/audio-type.component';
import { VideoTypeComponent } from './questions-type/video-type/video-type.component';
import { DocTypeComponent } from './questions-type/doc-type/doc-type.component';
import { RepeaterType } from "./questions-type/repeater-type/repeater-type";
// Components for Question Types

import { AssignTeamComponent, CentralPanelComponent } from './centralPanel/central-panel.component';
import { FileUtil } from './newSurveyerDialog/file.util';
import { Constants } from './newSurveyerDialog/test.constants';

import { RatingComponent } from './shared/rating/rating.component';
import { IonRangeSliderModule } from "../../node_modules/ng2-ion-range-slider";

import { SubjectiveNaturalWholeDecimalLocationPictureMobileTypeComponent } from './oldCentralPannel/subjective-natural-whole-decimal-location-picture-mobile-type/subjective-natural-whole-decimal-location-picture-mobile-type.component';
import { CalendarCreateTypeComponent } from './oldCentralPannel/calendar-type/calendar-type.component';
import { RadioCheckboxDropdownTypeComponent } from './oldCentralPannel/radio-checkbox-dropdown-type/radio-checkbox-dropdown-type.component';
import { CascadingDropdownTypeComponent } from './oldCentralPannel/cascading-dropdown-type/cascading-dropdown-type.component';
import { DependentComponent } from './oldCentralPannel/dependent/dependent.component';
import { AgeDependentComponent } from './oldCentralPannel/age-dep/age-dep.component';
import { DependentQuestionsComponent } from './centralPanel/dependenQuestions/dep-ques.component';


import { Authguard } from "./shared/services/authguard-service";
import { LogInGuard } from "./shared/services/logInGuard";
import { SecondLanguageService } from "./shared/services/second-language.service";
import { RepeaterFormOpenService } from "./shared/services/repeater-form-open.service";
import { AreYouSureDialogComponent } from "./centralPanel/dependenQuestions/are-you-sure-dialog/are-you-sure-dialog-component";
import { LeftTabActiveService } from "./shared/services/left-tab-active.service";
import { EditAnomalyDialogComponent } from "./editAnomalyDialog/edit-anomaly-dialog.component";
import { EditAgeDialogComponent } from "./editAgeDialog/edit-age-dialog.component";
import { BroadcastAgeService } from "./shared/services/broadcast-age.service";
import { SettingsOpenService } from "./shared/services/settings-open.service";
import { BroadcastAnomaliesService } from "./shared/services/broadcast-anomalies.service";
import { BroadcastUserResService } from "./shared/services/broadcast-user-res.service";
import { CascadingJSONService } from "./shared/services/cascading-json.service";
import { NavigateUrlService } from './shared/services/navigate-url.service';
import { superAdminService } from './shared/services/superAdminService';
import { RestApiService } from "./shared/restApiServices/restapi.service";
import { NativeWindoRefService } from "./shared/services/native-windo-ref.service";
import { CascadingTypeComponent } from "./questions-type/cascading-type/cascading-type.component";
import { TextAreaTypeComponent } from "./questions-type/text-area-type/text-area-type.component";
import { NewSurveyDialogComponent } from "./newSurveyDialog/new-survey-dialog.component";
import { SurveyersComponent, SurveyorDialogComponent } from './surveyers/surveyers.component';
import { GroupsComponent } from './groups/groups.component';
import { QuestionnairesComponent, DeleteSurveyDialogComponent, CopySurveyDialogComponent, EditSurveyInfoComponent } from './questionnaires/questionnaires.component';
import { ShareSurveyservice } from './questionnaires/share-superadmin-dialog';
import { shareSurvey } from './questionnaires/share-admin-dialog'
import { AccessSurveyservice } from './questionnaires/AccessSurveyservice';
import { ViewSurveyservice } from './questionnaires/viewInfoservice';
import { NewSurveyerDialogComponent } from './newSurveyerDialog/new-surveyer-dialog.component';
import { ManageSurveyerDialogComponent } from './manage-surveyer-dialog/manage-surveyer-dialog.component';
import { NewGroupDialogComponent } from './new-group-dialog/new-group-dialog.component';
import { ManageGroupDialogComponent } from './manage-group-dialog/manage-group-dialog.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ConfirmSignUpComponent } from './confirm-sign-up/confirm-sign-up.component';
import { DeleteAlertDialogComponent } from './delete-alert-dialog/delete-alert-dialog.component';
import { DeleteGroupDialogComponent } from './delete-group-dialog/delete-group-dialog.component';
import { DataSurveysComponent, DownloadDialogComponent, MapDialogComponent } from './data-surveys/data-surveys.component';
import { ForgotPasswordComponent } from './forgotPassword/forgotPassword.component';
import { CodeForgotPasswordComponent } from './getCodeForgetPassword/codeforgotPass';
import { InviteManagerComponent } from './dashboard/dashboard.component';
import { TabsDataService } from './shared/services/tabs-data.service';
import { tutorialComponent } from './tutorial/tutorialComponent';
import { Templateservice } from './questionnaires/new-template';
import { FiltersDialogComponent } from './data-surveys/filter-dialog';
import { DetailsDialogComponent } from './manager/manager.component';
import { AddTeamDialogComponent } from './surveyers/surveyers.component'
import { DeleteManagerDialogComponent } from './manager/manager.component';
import { BlankSurveyDialogComponent } from "./newSurveyDialog/blank-survey-dialog.component";
import { SurveyTypeDialogComponent } from "./newSurveyDialog/surveytype.component";
import { OverviewDialogComponent } from "./newSurveyDialog/overview-dialog.component"
import { formOverviewComponent } from "./formoverview/form-overview.component";

/** Import generic table module */
import { GenericTableModule } from '@angular-generic-table/core';
import { CustomRowComponent } from './custom-row/custom-row.component';
import { ColumnSettingsModule } from '@angular-generic-table/column-settings';
import { AnalyticsSurveyComponent } from './analytics-survey/analytics-survey.component';

import { LoaderService } from "./shared/services/loader.service";
import { NoSurveyerService } from "./shared/services/no-surveyer.service";
import { NoManagerService } from './shared/services/no-manager.service'
import { NoGroupService } from "./shared/services/no-group.service";
import { SelectedQnrService } from "./shared/services/selected-qnr.service";
import { PlanService } from "./shared/services/planService";
import { ShowToastyService } from "./shared/services/showToastyService";
import { QuestionnaireTypeService } from "./shared/services/questionnaire-type-service.service";
import { ZingChartService } from './shared/services/zing-chart.service';
import { RenderZingChartService } from "./shared/services/render.zingchart.service";

import { DefineAreaModalComponent } from './define-area-modal/define-area-modal.component';
import { RangeForRepeaterDialogComponent } from './range-for-repeater-dialog/range-for-repeater-dialog.component';
import { ProfileComponentComponent } from './profile-component/profile-component.component';
import { PaymentComponent } from './payment/payment.component';
import { SignUpBillingComponent } from './sign-up-billing/sign-up-billing.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { LogInBillingComponent } from './log-in-billing/log-in-billing.component';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { VerfyMailIDComponent } from "./profile-component/profile-component.component";
import { FillFormComponent } from './fill-form/fill-form.component';
import { FormQuestionsPreviewComponent } from './form-questions-preview/form-questions-preview.component';
import { ChangePlanModalComponent } from './change-plan-modal/change-plan-modal.component';
import { UpdateBillingInfoModalComponent } from './update-billing-info-modal/update-billing-info-modal.component';
import { DeleteAccountDialogComponent } from "./profile-component/profile-component.component";
import { VerifyMailIdmodalComponent } from './verify-mail-idmodal/verify-mail-idmodal.component';
import { GstinvoicedetailsComponent } from './gstinvoicedetails/gstinvoicedetails.component';
import { DialogBoxComponent } from './dialog-box/dialog-box.component';
import { HomeComponent } from './home/home.component';
import { ResponseChartComponent } from "./response-chart-dialog/response-chart.component";
import { VideoDialogComponent } from "./video-dialog/video-dialog.component";
import { PlanUpgrageDialogComponent } from "./plan-upgrage-dialog/plan-upgrage-dialog.component";
import { AddLocationQuestionComponent } from "./add-location-question/add-location-question.component";

import { KeysPipe } from "./price/keysPipe";
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppMaterialModule } from './app.material.module';
import { UserTooltipComponent } from "./data-surveys/user-tooltip.component";
import { UpdateBasicInfoComponent } from './update-basic-info/update-basic-info.component';
import { ViewPerformanceComponent } from './view-performance/view-performance.component';
import { PreviewDialogComponent } from './preview-dialog/preview-dialog.component';
import { DataAnalysisComponent } from './data-analysis/data-analysis.component';

const appRoutes: Routes = [
  {
    path: 'create-questionnaire/:id',
    component: CreateQuestionnaireComponent,
    canActivate: [LogInGuard]
  },
  {
    path: 'fillform/:id',
    component: FillFormComponent
    // This is independent please don't add any guard
  },
  {
    path: 'home',
    component: HomeComponent
  },
  // {
  //   path: 'formoverview/:id',
  //   component:DashboardComponent,
  //   children:[
  //     {
  //       path:'',
  //       component:formOverviewComponent,
  //       outlet:'dashboard-content'
  //     }
  //   ]
  // },
  {
    path: 'logIn',
    component: LogInBillingComponent,
    canActivate: [Authguard]
  },
  {
    path: 'pricing',
    component: PriceComponent
  },
  {
    path: 'userProfile',
    component: ProfileComponentComponent,
    canActivate: [LogInGuard]
  },
  {
    path: 'checkout',
    component: CheckoutComponent,
    canActivate: [LogInGuard]
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [LogInGuard]
  },
  {
    path: 'signUp',
    component: SignUpBillingComponent,
    canActivate: [Authguard]
  },
  {
    path: 'codeforgotPass',
    component: CodeForgotPasswordComponent
  },
  {
    path: 'confirmSignUp',
    component: ConfirmSignUpComponent
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent
  },
  {
    path: 'questionnaires',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: QuestionnairesComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'Surveyors',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: SurveyersComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'data-analysis',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: DataAnalysisComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'groups',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: GroupsComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'survey-data',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: DataSurveysComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'view-performance',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: ViewPerformanceComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'analytics-data',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: AnalyticsSurveyComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'manager-data',
    component: DashboardComponent,
    canActivate: [LogInGuard],
    children: [
      {
        path: '',
        component: ManagerSurveyComponent,
        outlet: 'dashboard-content'
      }
    ]
  },
  {
    path: 'payment-success',
    component: PaymentSuccessComponent,
    canActivate: [LogInGuard]
  },
  {
    path: 'termsAndConditions',
    component: TermsAndConditionsComponent
  },
  {
    path: 'privacyPolicy',
    component: PrivacyPolicyComponent
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }
];


@NgModule({
  declarations: [
    DeleteSurveyDialogComponent,
    CopySurveyDialogComponent,
    EditSurveyInfoComponent,
    ForgotPasswordComponent,
    formOverviewComponent,
    ShareSurveyservice,
    shareSurvey,
    Templateservice,
    AccessSurveyservice,
    ViewSurveyservice,
    MapDialogComponent,
    AppComponent,
    OldCentralPannelComponent,
    CreateQuestionnaireComponent,
    LeftPannelComponent,
    QuestionnairePreviewComponent,
    LogInDialogComponent,
    DashboardComponent,
    ManagerSurveyComponent,
    CheckboxTypeComponent,
    RadioTypeComponent,
    RatingTypeComponent,
    TimeTypeComponent,
    EmojiTypeComponent,
    RankTypeComponent,
    SectionBreakComponent,
    MapTypeComponent,
    PictureInputTypeComponent,
    SelectedDropdownTypeComponent,
    CalendarTypeComponent,
    CalendarTypeDialogComponent,
    MobileNumTypeComponent,
    SubjectiveTypeComponent,
    NaturalWholeNumTypeComponent,
    CalendarWithDateTypeComponent,
    CodeForgotPasswordComponent,
    SubjectiveNaturalWholeDecimalLocationPictureMobileTypeComponent,
    CalendarCreateTypeComponent,
    CascadingDropdownTypeComponent,
    RadioCheckboxDropdownTypeComponent,
    AgeDependentComponent,
    DependentComponent,
    CentralPanelComponent,
    EditQuestionDialogComponent,
    DependentQuestionsComponent,
    AreYouSureDialogComponent,
    EditAnomalyDialogComponent,
    EditAgeDialogComponent,
    InviteManagerComponent,
    CascadingTypeComponent,
    TextAreaTypeComponent,
    NewSurveyDialogComponent,
    SurveyersComponent,
    GroupsComponent,
    QuestionnairesComponent,
    NewSurveyerDialogComponent,
    ManageSurveyerDialogComponent,
    NewGroupDialogComponent,
    ManageGroupDialogComponent,
    SignUpComponent,
    ConfirmSignUpComponent,
    DeleteAlertDialogComponent,
    DeleteManagerDialogComponent,
    DeleteGroupDialogComponent,
    DataSurveysComponent,
    CustomRowComponent,
    AnalyticsSurveyComponent,
    RatingComponent,
    RangetypeComponent,
    NewManagerDialogComponent,
    tutorialComponent,
    FiltersDialogComponent,
    DetailsDialogComponent,
    AddTeamDialogComponent,
    BlankSurveyDialogComponent,
    SurveyTypeDialogComponent,
    OverviewDialogComponent,
    DefineAreaModalComponent,
    RangeForRepeaterDialogComponent,
    PriceComponent,
    ProfileComponentComponent,
    PaymentComponent,
    SignUpBillingComponent,
    CheckoutComponent,
    LogInBillingComponent,
    ChangePasswordDialogComponent,
    VerfyMailIDComponent,
    FillFormComponent,
    FormQuestionsPreviewComponent,
    PaymentSuccessComponent,
    ChangePlanModalComponent,
    UpdateBillingInfoModalComponent,
    DeleteAccountDialogComponent,
    VerifyMailIdmodalComponent,
    GstinvoicedetailsComponent,
    DialogBoxComponent,
    HomeComponent,
    KeysPipe,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    AppFooterComponent,
    AudioTypeComponent,
    VideoTypeComponent,
    DocTypeComponent,
    RepeaterType,
    ResponseChartComponent,
    VideoDialogComponent,
    UserTooltipComponent,
    PlanUpgrageDialogComponent,
    AddLocationQuestionComponent,
    UpdateBasicInfoComponent,
    ViewPerformanceComponent,
    PreviewDialogComponent,
    SurveyorDialogComponent,
    AssignTeamComponent,
    DataAnalysisComponent,
    DownloadDialogComponent
  ],
  imports: [
    BrowserModule,
    CdkTableModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    HttpClientModule,
    MatNativeDateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatListModule,
    MatTableModule,
    MatDialogModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    RouterModule.forRoot(appRoutes),
    DndModule.forRoot(),
    IonRangeSliderModule,
    InfiniteScrollModule,
    TranslateModule.forRoot(),
    DragulaModule,
    TagInputModule,
    ToastyModule.forRoot(),
    GenericTableModule,
    ColumnSettingsModule,
    LoadersCssModule,
    LeafletModule,
    NgbModule.forRoot(),
    LeafletModule.forRoot(),
    LeafletMarkerClusterModule.forRoot(),
    MatTooltipModule,
    MatExpansionModule,
    ClipboardModule,
    ImageCropperModule,
    AppMaterialModule,
    MatVideoModule,
    MatSnackBarModule,
    AmazingTimePickerModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue: '/survey-manager'},BroadcastEventService,GetQuestionsFromJson,SecondLanguageService,RepeaterFormOpenService,LeftTabActiveService,BroadcastAgeService,SettingsOpenService, BroadcastAnomaliesService, BroadcastUserResService,RatingComponent,
  CascadingJSONService,NavigateUrlService,RestApiService,NativeWindoRefService,LoaderService,NoSurveyerService,NoGroupService,NoManagerService , SelectedQnrService,  superAdminService, TabsDataService,FileUtil, Constants , PlanService, ShowToastyService, Authguard,LogInGuard,ZingChartService,RenderZingChartService,
    AmazingTimePickerService,QuestionnaireTypeService, DatePipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    CalendarTypeDialogComponent,
    EditQuestionDialogComponent,
    AreYouSureDialogComponent,
    EditAnomalyDialogComponent,
    EditAgeDialogComponent,
    NewSurveyDialogComponent,
    NewSurveyerDialogComponent,
    ManageSurveyerDialogComponent,
    DetailsDialogComponent,
    NewGroupDialogComponent,
    ManageGroupDialogComponent,
    DeleteAlertDialogComponent,
    DeleteGroupDialogComponent,
    CustomRowComponent,
    ViewSurveyservice,
    CopySurveyDialogComponent,
    ShareSurveyservice,
    shareSurvey,
    Templateservice,
    AccessSurveyservice,
    DeleteSurveyDialogComponent,
    MapDialogComponent,
    EditSurveyInfoComponent,
    InviteManagerComponent,
    NewManagerDialogComponent,
    tutorialComponent,
    FiltersDialogComponent,
    AddTeamDialogComponent,
    DeleteManagerDialogComponent,
    BlankSurveyDialogComponent,
    SurveyTypeDialogComponent,
    OverviewDialogComponent,
    DefineAreaModalComponent,
    RangeForRepeaterDialogComponent,
    ChangePasswordDialogComponent,
    VerfyMailIDComponent,
    LogInDialogComponent,
    ChangePlanModalComponent,
    UpdateBillingInfoModalComponent,
    DeleteAccountDialogComponent,
    VerifyMailIdmodalComponent,
    GstinvoicedetailsComponent,
    DialogBoxComponent,
    ResponseChartComponent,
    VideoDialogComponent,
    UserTooltipComponent,
    PlanUpgrageDialogComponent,
    AddLocationQuestionComponent,
    UpdateBasicInfoComponent,
    PreviewDialogComponent,
    SurveyorDialogComponent,
    AssignTeamComponent  ,
    DownloadDialogComponent  ],
  exports: [
  RouterModule
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts